import Link from "next/link";
import ScreenUsers from "@svg/screen-users";

interface FooterOrganizationsProps {
  showButtonOrganizationFooter?: boolean;
}

const FooterOrganizations: React.FC<FooterOrganizationsProps> = ({
  showButtonOrganizationFooter = true,
}) => {
  return (
    <div className=" w-full bg-[#f7f7f7] py-8 mx-auto mb-8">
      <div className=" w-full container-bs mx-auto flex flex-col items-center justify-center">
        <div className="lg:pl-5 md:p-0 p-0 text-[#6C757D] font-normal mb-5">
          <p className="text-center mdm:text-[14px] text-[12px] leading-[24px]">
            سازمان‌های پیشرو و هدفمند با آموزش‌های سازمانی فرادرس، فرصت رشد و
            ارتقای مهارت را برای کارکنان خود فراهم ساخته‌اند.
          </p>
        </div>
        <div className="flex items-center justify-between flex-wrap w-full lg:mt-0 md:mt-3 mt-3">
          <div className="md:w-2/12 w-4/12 flex md:justify-center md:pr-0 justify-start pr-2 group">
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/elmosanat_gray.png"
              className="mdm:h-[86px] h-[61px] group-hover:hidden"
              alt="industrialUni"
            />
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/elmosanat.png"
              className="mdm:h-[86px] h-[61px] hidden group-hover:block"
              alt="industrialUni"
            />
          </div>
          <div className="md:w-2/12 w-4/12 flex justify-center group">
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/varagh_gray.png"
              className="mdm:h-[70px] h-[60px] group-hover:hidden"
              alt="varaghCompany"
            />
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/varagh.png"
              className="mdm:h-[70px] h-[60px] hidden group-hover:block"
              alt="varaghCompany"
            />
          </div>
          <div className="md:w-2/12 w-4/12 flex md:justify-center md:pl-0 justify-end pl-2 group">
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/zamyad_gray.png"
              className="mdm:h-[86px] h-[61px] group-hover:hidden"
              alt="zamyad"
            />
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/zamyad.png"
              className="mdm:h-[86px] h-[61px] hidden group-hover:block"
              alt="zamyad"
            />
          </div>
          <div className="md:w-2/12 w-4/12 flex md:justify-center md:pr-0 justify-start group">
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/mobin_gray.png"
              className="mdm:h-[105px] h-[80px] group-hover:hidden"
              alt="mobin"
            />
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/mobin.png"
              className="mdm:h-[105px] h-[80px] hidden group-hover:block"
              alt="mobin"
            />
          </div>
          <div className="md:w-2/12 w-4/12 flex justify-center group">
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/foolad_gray.png"
              className="mdm:h-[105px] h-[65px] group-hover:hidden"
              alt="foolad"
            />
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/foolad.png"
              className="mdm:h-[105px] h-[65px] hidden group-hover:block"
              alt="foolad"
            />
          </div>
          <div className="md:w-2/12 w-4/12 flex md:justify-center md:pl-0 justify-end pl-2 group">
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/mellat_gray.png"
              className="mdm:h-[100px] h-[68px] group-hover:hidden"
              alt="mellat"
            />
            <img
              src="https://cdn.faradars.org/wp-content/uploads/2022/11/22/mellat.png"
              className="mdm:h-[100px] h-[68px] hidden group-hover:block"
              alt="mellat"
            />
          </div>
        </div>
        {showButtonOrganizationFooter && (
          <div className="flex items-center justify-center mt-5">
            <Link
              href="/faradars-for-organizations"
              target="_blank"
              className="inline-flex items-center justify-center py-[12px] px-[24px] h-[48px] bg-[#FFA500] rounded-[10px] font-medium text-[16px] leading-[24px] text-white w-[194px]"
              prefetch={false}
            >
              <ScreenUsers width={25} height={18} fill="#FFFFFF" />
              <span className="mr-2">آموزش سازمانی</span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default FooterOrganizations;
